export const AREA_OPTIONS = Object.freeze([
    { value: 'C00201', label: '豊洲駅周辺' },
    { value: 'C00202', label: '月島駅周辺' },
    { value: 'C00203', label: '門前仲町周辺' },
    { value: 'C00204', label: '豊洲市場周辺' },
]);

export const GENRE_OPTIONS = Object.freeze([
    ['C00101', 'サービス'],
    ['C00102', 'イベント'],
    ['C00104', 'ピックアップニュース'],
    ['C00103', 'お知らせ'],
]);

export const SCENE_OPTIONS = Object.freeze([
    ['C00301', '１人'],
    ['C00302', 'デート'],
    ['C00303', '友達'],
    ['C00304', '家族'],
]);

export const GENDER_OPTIONS = Object.freeze([
    ['0', '男性'],
    ['1', '女性'],
    ['2', '未選択'],
]);

export const AGE_OPTIONS = Object.freeze([
    ['0-20', '20歳未満'],
    ['20-30', '20代'],
    ['30-40', '30代'],
    ['40-50', '40代'],
    ['50-60', '50代'],
    ['60-70', '60代'],
    ['70-', '70代以上'],
]);
